module.exports = __webpack_public_path__ + "main/images/shared/listen-articles@2x.f21c5c2628fcb6953d6330379af9d7e8.png";